module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-salary"
  }, [_c('div', {
    staticClass: "sub-salary__header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sub-salary__header__left"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--with-icon",
    on: {
      "click": function($event) {
        return _vm.setIsShowSalarySettings(true)
      }
    }
  }, [_c('svg', {
    staticClass: "mr-2 h-4 w-4",
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 15 15",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z",
      "fill": "currentColor",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n        Opsætning\n      ")]), _vm._v(" "), (_vm.isSchoolSelectorOn) ? _c('SchoolsSelector', {
    attrs: {
      "permission": _vm.permission,
      "schools": _vm.userSchools,
      "selectedSchoolIds": _vm.selectedSchoolIds
    },
    on: {
      "toggleSchool": _vm.toggleSchool
    }
  }) : _vm._e(), _vm._v(" "), _c('DoDatePickerRange', {
    attrs: {
      "allowSameDate": true,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "dateShortCutsProps": _vm.dateShortCuts,
      "maximumDateRange": 89
    },
    on: {
      "startChanged": _vm.startDateChanged,
      "endChanged": _vm.endDateChanged,
      "datesChanged": _vm.datesChanged
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sub-salary__sub-header"
  }, [_c('SalaryFilters', {
    attrs: {
      "activeFilter": _vm.activeFilter,
      "userDaysSorted": _vm.userDaysSorted,
      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
    },
    on: {
      "change": function($event) {
        return _vm.setFilter($event)
      }
    }
  }), _vm._v(" "), (_vm.activeFilter === 'approved' && _vm.userDaysApproved.length > 0) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit text-dark no-print",
    class: {
      'do-bttn--loading': _vm.isBulkSending
    },
    attrs: {
      "disabled": _vm.isBulkSending
    },
    on: {
      "click": function($event) {
        return _vm.openBulkSendConfirm()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.bulkSendButtonLabel) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-salary__body"
  }, [(_vm.isLoading) ? _c('Loader') : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.usersAndEventsFiltered.length < 1) ? _c('h2', {
    staticClass: "text-explainer marg-1-top"
  }, [(_vm.selectedSchoolIds.length > 0) ? [_vm._v("Ingen vikartimer i perioden")] : [_vm._v("Ingen skoler valgt")]], 2) : [_c('ul', {
    staticClass: "user-list"
  }, _vm._l((_vm.usersPackedInDaysWithProps), function(user) {
    return _c('li', {
      staticClass: "user-list__user"
    }, [_c('div', {
      staticClass: "user-list__user__header"
    }, [_c('h4', [_vm._v(_vm._s(user.v_user_name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "user-list__user__header__right"
    }, [_c('ul', _vm._l((user.v_user_sums), function(sum) {
      return _c('li', {
        key: sum.vId,
        class: {
          'user-list__user__footer__sums__sum--not-set': sum.employment_not_set
        }
      }, [_vm._v("\n                  " + _vm._s(sum.employment_title) + " " + _vm._s(sum.costCenter ? '[' + sum.costCenter + '] ' : '') + "\n                  "), _c('b', [_vm._v(_vm._s(sum.minutes_humanized))])])
    }), 0), _vm._v(" "), _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
      }],
      staticClass: "do-bttn do-bttn--small no-print",
      attrs: {
        "content": "Se alle dage på personen"
      },
      on: {
        "click": function($event) {
          return _vm.setActiveUserId(user.user_id)
        }
      }
    }, [_c('span', {
      staticClass: "icon-enlarge2"
    })])])]), _vm._v(" "), _vm._l((user.days), function(userDay) {
      return _c('table', {
        key: userDay.day,
        staticClass: "user-list__user__table",
        class: {
          'user-list__user__table--active': userDay.v_is_open
        }
      }, [_c('thead', {
        on: {
          "click": function($event) {
            return _vm.setTheActiveUserDay(userDay)
          }
        }
      }, [_c('tr', [_c('th', [_vm._v(_vm._s(userDay.v_date_formatted) + "\n                "), (userDay.error && Object.keys(userDay.error).length) ? _c('span', {
        staticClass: "do-pill do-pill--yellow"
      }, [_vm._v("\n                  Overførselsfejl\n                ")]) : _vm._e()]), _vm._v(" "), (userDay.v_is_open) ? _c('th', [_vm._v("Kalender")]) : _vm._e(), _vm._v(" "), (userDay.v_is_open) ? _c('th', [_vm._v("Type")]) : _vm._e(), _vm._v(" "), (userDay.v_is_open) ? _c('th', [_vm._v("Vikar for")]) : _vm._e(), _vm._v(" "), (userDay.v_is_open) ? _c('th', [_vm._v("Ansættelse")]) : _vm._e(), _vm._v(" "), (_vm.isSalaryIntegrationActive && userDay.v_is_open) ? _c('th', [_vm._v("Lønkode")]) : _vm._e(), _vm._v(" "), (_vm.costCenters.length > 0 && userDay.v_is_open) ? _c('th', [_vm._v("Omkostningssted")]) : _vm._e(), _vm._v(" "), (userDay.v_is_open) ? _c('th', {
        staticClass: "no-print"
      }) : _vm._e(), _vm._v(" "), _c('th', {
        staticClass: "user-list__user__table__arrow"
      }, [(userDay.v_unfilled) ? _c('svg', {
        staticClass: "tw-icon tw-icon--red",
        attrs: {
          "viewBox": "0 0 24 24",
          "fill": "none",
          "stroke": "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }, [_c('path', {
        attrs: {
          "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
        }
      }), _vm._v(" "), _c('line', {
        attrs: {
          "x1": "12",
          "y1": "9",
          "x2": "12",
          "y2": "13"
        }
      }), _vm._v(" "), _c('line', {
        attrs: {
          "x1": "12",
          "y1": "17",
          "x2": "12.01",
          "y2": "17"
        }
      })]) : _vm._e(), _vm._v(" "), (!userDay.v_is_open) ? _c('span', {
        staticClass: "icon-arrow-up4"
      }) : _c('span', {
        staticClass: "icon-arrow-down4"
      })])])]), _vm._v(" "), (userDay.v_is_open) ? [_c('SalarySubsPerfUserDay', {
        attrs: {
          "user": user,
          "userDay": userDay,
          "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
          "salaryCodes": _vm.salaryCodes,
          "costCenters": _vm.costCenters
        },
        on: {
          "updatePropOnLesson": _vm.updatePropOnLesson
        }
      }), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
        attrs: {
          "colspan": _vm.isSalaryIntegrationActive ? 9 : _vm.costCenters.length > 0 ? 8 : 7
        }
      }, [_c('div', {
        staticClass: "user-list__user__footer"
      }, [_vm._l((_vm.parseUserErrors(userDay.error)), function(error, index) {
        return (userDay.error) ? _c('span', {
          key: index,
          staticClass: "do-pill do-pill--yellow do-pill--with-icon"
        }, [_c('svg', {
          staticClass: "tw-icon tw-icon--yellow",
          attrs: {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }, [_c('path', {
          attrs: {
            "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
          }
        }), _vm._v(" "), _c('line', {
          attrs: {
            "data-v-050a44fb": "",
            "x1": "12",
            "y1": "9",
            "x2": "12",
            "y2": "13"
          }
        }), _vm._v(" "), _c('line', {
          attrs: {
            "x1": "12",
            "y1": "17",
            "x2": "12.01",
            "y2": "17"
          }
        })]), _vm._v("\n                      " + _vm._s(error) + "\n                    ")]) : _vm._e()
      }), _vm._v(" "), _c('ul', {
        staticClass: "user-list__user__footer__sums"
      }, _vm._l((userDay.v_sums), function(sum) {
        return _c('li', {
          key: sum.vId,
          class: {
            'user-list__user__footer__sums__sum--not-set': sum.employment_not_set
          }
        }, [_vm._v("\n                        " + _vm._s(sum.employment_title) + " " + _vm._s(sum.costCenter ? '[' + sum.costCenter + ']: ' : '') + "\n                        "), _c('b', [_vm._v(_vm._s(sum.minutes_humanized))]), _vm._v(" "), _c('button', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              onShow: _vm.hideTippy,
              trigger: 'manual',
              arrow: true,
              placement: 'top',
              zIndex: 2147483010
            }),
            expression: "{\n                                  onShow: hideTippy,\n                                  trigger: 'manual',\n                                  arrow: true,\n                                  placement : 'top',\n                                  zIndex: 2147483010\n                                }"
          }],
          staticClass: "bttn bttn--white bttn--small do-copy-bttn",
          attrs: {
            "content": 'Kopieret ' + sum.minutes_to_copy
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.copyToClipboard(sum.minutes_to_copy, $event)
            }
          }
        }, [_c('svg', {
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "height": "48",
            "viewBox": "0 0 48 48",
            "width": "48"
          }
        }, [_c('path', {
          attrs: {
            "d": "M0 0h48v48h-48z",
            "fill": "none"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M32 2h-24c-2.21 0-4 1.79-4 4v28h4v-28h24v-4zm6 8h-22c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h22c2.21 0 4-1.79 4-4v-28c0-2.21-1.79-4-4-4zm0 32h-22v-28h22v28z"
          }
        })])])])
      }), 0), _vm._v(" "), (userDay.state === 'draft') ? [(_vm.getIsDayValidated(userDay)) ? _c('button', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: true,
            animateFill: false,
            animation: 'shift-away',
            zIndex: '999999992',
            boundary: 'window'
          }),
          expression: "{\n                          arrow: true,\n                          animateFill: false,\n                          animation : 'shift-away',\n                          zIndex: '999999992',\n                          boundary: 'window'\n                        }"
        }],
        staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled",
        attrs: {
          "content": _vm.validationTxt
        }
      }, [_vm._v("\n                        Godkend\n                      ")]) : _c('button', {
        staticClass: "do-bttn do-bttn--submit",
        class: {
          'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
        },
        on: {
          "click": function($event) {
            return _vm.approveDay(userDay)
          }
        }
      }, [_vm._v("Godkend\n                      ")])] : _vm._e(), _vm._v(" "), (userDay.state === 'approved') ? _c('div', {
        staticClass: "submit-buttons"
      }, [_c('button', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: true,
            animateFill: false,
            animation: 'shift-away',
            zIndex: '999999992',
            boundary: 'window'
          }),
          expression: "{\n                          arrow: true,\n                          animateFill: false,\n                          animation : 'shift-away',\n                          zIndex: '999999992',\n                          boundary: 'window'\n                        }"
        }],
        staticClass: "do-bttn do-bttn--danger",
        class: {
          'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
        },
        attrs: {
          "content": 'Dagen vil blive genberegnet'
        },
        on: {
          "click": function($event) {
            return _vm.unApproveDay(userDay)
          }
        }
      }, [_vm._v("\n                        Fortryd godkendelse\n                      ")]), _vm._v(" "), _c('button', {
        staticClass: "do-bttn do-bttn--submit",
        class: {
          'do-bttn--submit--loading': _vm.getIsSubmitting(userDay)
        },
        on: {
          "click": function($event) {
            return _vm.changeStateIsSent(userDay)
          }
        }
      }, [_vm._v("\n                        " + _vm._s(_vm.isSalaryIntegrationActive ? 'Send til lønsystem' : 'Er indberettet') + "\n                      ")])]) : _vm._e(), _vm._v(" "), (userDay.approved_at) ? _c('span', {
        staticClass: "do-approved-by"
      }, [_vm._v("\n                      " + _vm._s(userDay.v_approved) + "\n                    ")]) : _vm._e()], 2)])])])] : _vm._e()], 2)
    })], 2)
  }), 0)]], 2), _vm._v(" "), (_vm.activeUserId) ? _c('SalarySubsPerfUser', {
    attrs: {
      "activeUserId": _vm.activeUserId,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "usersPackedInDaysWithProps": _vm.usersPackedInDaysWithProps,
      "userDaysSorted": _vm.userDaysSorted,
      "activeFilter": _vm.activeFilter,
      "theUserDaySubmitting": _vm.theUserDaySubmitting,
      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
      "isOpusIntegrationActive": _vm.isOpusIntegrationActive,
      "salaryCodes": _vm.salaryCodes,
      "costCenters": _vm.costCenters,
      "schoolId": _vm.schoolId,
      "isBulkSending": _vm.isBulkSending
    },
    on: {
      "updatePropOnLesson": _vm.updatePropOnLesson,
      "setFilter": function($event) {
        return _vm.setFilter($event)
      },
      "approveDay": function($event) {
        return _vm.approveDay($event)
      },
      "unApproveDay": function($event) {
        return _vm.unApproveDay($event)
      },
      "changeStateIsSent": function($event) {
        return _vm.changeStateIsSent($event)
      },
      "bulkSendUserDays": _vm.openBulkSendConfirm,
      "close": function($event) {
        return _vm.setActiveUserId(null)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowSalarySettings) ? _c('SalarySettings', {
    attrs: {
      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
      "isSDIntegrationActive": _vm.isSDIntegrationActive
    },
    on: {
      "update": _vm.onUpdate,
      "close": function($event) {
        return _vm.setIsShowSalarySettings(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isConfirmBulkSend) ? _c('DModal', {
    attrs: {
      "showClose": false,
      "isBgOverlay": true,
      "isCloseOnEsc": !_vm.isBulkSending,
      "isCloseOnBgClick": !_vm.isBulkSending,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": _vm.cancelBulkSend
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal--small text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.bulkSendButtonLabel))]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.cancelBulkSend
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('p', [_vm._v(_vm._s(_vm.bulkSendConfirmText))])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1-right"
  }, [_c('div', {
    staticClass: "d-modal__buttons__child"
  }, [_c('button', {
    staticClass: "do-bttn",
    attrs: {
      "disabled": _vm.isBulkSending
    },
    on: {
      "click": _vm.cancelBulkSend
    }
  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isBulkSending,
      'do-bttn--submit--disabled': _vm.isBulkSending
    },
    attrs: {
      "disabled": _vm.isBulkSending
    },
    on: {
      "click": _vm.bulkSendApprovedDays
    }
  }, [_vm._v("\n            " + _vm._s(_vm.bulkSendButtonLabel) + "\n          ")])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-salary__header__left"
  }, [_c('h1', [_vm._v("Vikarløn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "do-bttn do-bttn--with-icon",
    attrs: {
      "href": "https://app.docendo.dk/app#/helpdesk?article=285",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon-question3"
  }), _vm._v("\n        Guide\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11b82438!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySubsPerf.vue
// module id = 1766
// module chunks = 1